<style scoped>
.bt_footer_mobile {
    width: 65px;
    height: 65px;
    position: fixed;
    right: 15px;
    bottom: 20px;
    z-index: 100;
    font-size: 15px !important;
    border-radius: 50%;

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
}

@media screen and (max-width: 767px) {
    .bt_footer_mobile {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

@media screen and (min-width: 768px) {
    .bt_footer_mobile {
        display: none;
    }
}
</style>

<template>
    <!-- <div class="bt_footer_mobile"> -->
    <a type="button" href="#receba" class="btn btn-success bt_footer_mobile fw-bold">QUERO</a>
    <!-- </div> -->
</template>